import { Pagination, PayOrderBasicInfo, REDIRECT_TYPE } from '@/logic/services';

import { MyOrderModel } from '@/logic/services/my-booking';
import { PaymentGatewayModel } from '@/logic/services/cinemas';
import { UserAuthModel } from '@/logic/state';

export enum TopUpStatus {
  pending = 'PENDING',
  done = 'DONE',
}
export const E_WALLET = 'E_WALLET';

export enum TicketCancelStatus {
  orderHasOffer = 'ORDER_HAS_OFFER',
  walletPaymentStrategyLimitation = 'E_WALLET_PAYMENT_STRATEGY_LIMITATION',
  cashbackPaymentStrategyLimitation = 'CASHBACK_WALLET_PAYMENT_STRATEGY_LIMITATION',
  closeToShowtime = 'CLOSE_TO_SHOWTIME',
  cancelationLimitationPerDay = 'CANCELLATION_LIMITATION_PER_DAY',
  cancelationLimitationPerWeek = 'CANCELLATION_LIMITATION_PER_WEEK',
  hasRefundPaymentRequest = 'HAS_REFUND_PAYMENT_REQUEST',
  tabbyPaymentStrategyLimitation = 'TABBY_PAYMENT_STRATEGY_LIMITATION',
}

export interface TopUpModel {
  id: number;
  paymentGateway: PaymentGatewayModel;
  status: TopUpStatus;
}

export interface InitTopUpResponse {
  topUp: TopUpModel;
}

export interface GetTopUpByIdResponse {
  topUp: TopUpModel;
}

export interface PayTopUpRequest extends PayOrderBasicInfo {
  paymentStrategy: 'CARD' | 'TOKEN' | 'STC_PAY';
  cardId?: number;
  cvv?: string;
  amount: number;
  isApplePayment?: boolean;
  checkoutPaymentContext?: string;
  otp?: string;
}

export interface PayTopUpResponse {
  topUp: TopUpModel;
  redirect: string;
  redirectType: REDIRECT_TYPE;
}

export interface Transaction {
  id: number;
  type: TransactionType;
  amount: number;
  createdAt: string;
  expireAt?: string;
  schema?: string;
  restAmount?: number;
  isMada: boolean;
}

export type TransactionType =
  | 'TOP_UP'
  | 'REDEEM'
  | 'REFUND'
  | 'CASHBACK'
  | 'CASHBACK_REDEEM'
  | 'CASHBACK_EARNED';
export interface GetTransactionsResponse {
  data: Transaction[];
  pagination: Pagination;
}

export interface GetBalanceResponse {
  balance: number;
  transaction: Transaction;
}

export interface CheckTicketCancelResponse {
  reason: TicketCancelStatus;
  canCancel: boolean;
  expireAt: string;
}

export interface CancelationReason {
  id: number;
  title: string;
}

export interface GetCancelationReasonsResponse {
  data: CancelationReason[];
}

export interface CancelTicketRequest {
  cancellationReasonId: number;
}

export interface CancelTicketResponse {
  order: MyOrderModel;
}

export interface VerifyUserEmailRequest {
  code: string;
}

export interface VerifyUserEmailResponse {
  user: UserAuthModel;
}
export interface DetailedBalanceResponse {
  eWalletBalance: number;
  cashbackWalletBalance: number;
  totalBalance: number;
}
